import React from 'react';
import { makeStyles,  createStyles, Link } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    right: {
      textAlign: 'right'
    }
  }),
);

const TermsBodyJP: React.FC = () => {
  const classes = useStyles();
  return (
    <div>
      <h3>利用規約</h3>
      <p className={classes.right}>制定日2021年4月21日</p>
      <h4>第１条 本サービスのご利用</h4>
      <p>本規約において「本サービス」とは、全日本空輸株式会社（以下「当社」という）が当社または提携社ホームページ及び当社モバイルアプリからの連携により提供する「空港アクセスナビ」上で提供する一連サービスを指します。ご利用にあたっては、本規約内容をご確認頂き、ご同意頂ける場合のみ本サービスをご利用ください。なお、本サービスをご利用頂いた場合は、本規約を本サービスの利用に関するお客様と当社との間の契約の内容とすることにご同意頂いたものとみなします。</p>

      <h4>第２条 本サービスの構成とご利用条件</h4>
      <p>本サービスは無償にてご利用頂けます。ただし、お客様が本サービスをご利用いただくにあたって発生する通信費やインターネットプロバイダーによる課金、ウェブサイトに接続するためのコンピューター、モデム、携帯端末等の周辺機器及びソフトウェア等は、お客様の責任と負担にてご準備ください。</p>

      <h4>第３条 お客様の責任と義務</h4>
      <ol>
        <li>本規約及び当社が本サービスに関して本サービスのウェブサイト上に掲示、またはお客様に連絡する告知等の一切は、本規約と一体のものとして、お客様はこれら全てを遵守する義務を負います。なお、かかる告知等に本規約に相反、または矛盾する内容が記載される場合、本規約の規定を優先して適用します。</li>
        <li>本サービスの正確性、信頼性、安全性、完成度、有用性、時宜に適したものであるか否か、及び本サービスがお客様の特定目的に合致するか否かについては、お客様が自らの責任でご判断ください。</li>
        <li>お客様が、本サービスの利用に関して国内外の第三者から、問い合わせ、抗議、クレームを受けた場合や、提訴された場合は、お客様は自らの費用と責任をもってかかる問い合わせ、抗議、クレーム、訴訟に対応するものとします。</li>
      </ol>

      <h4>第４条 知的財産権</h4>
      <ol>
        <li>本サービスに表示される施設情報データの著作権は、Google©及び株式会社ゼンリンまたは当該二社に権利を許諾する第三者に帰属します。</li>
        <li>本サービスに表示される鉄道運行情報データの著作権は、株式会社レスキューナウまたは当該社に権利を許諾する第三者に帰属します。</li>
        <li>本サービスに表示される航空・鉄道・バス・船での経路検索データ（経路検索画面及び検索結果出力データ）の著作権は、株式会社ヴァル研究所または当該社に権利を許諾する第三者に帰属します。</li>
        <li>本サービスに表示される上記以外のデータの著作権は、当社または当該社に権利を許諾する第三者に帰属します。</li>
        <li>お客様は、本サービスでのみ、鉄道運行情報データ、路線図データ、空港情報、経路検索データ、駅名を含むデータ（以下、「乗換案内データ等」という）を閲覧することができます。お客様は、乗換案内データ等について、これ以外のいかなる権利も取得するものではありません。</li>
        <li>本サービスで提供する内容（時刻データを含みます）を無断で転載・複写し、または紙媒体、電磁媒体その他いかなる媒体に加工することも禁じます。</li>
      </ol>

      <h4>第５条 禁止事項</h4>
      <p>お客様は以下の行為をすることはできません。</p>
      <ol>
        <li>本サービスを個人的な利用を超えて、営利目的において利用する行為。</li>
        <li>本サービスを違法な目的で利用する行為。</li>
        <li>本サービスの複製、分解、追加、編集、削除、改変、改造及びその他方法、態様の如何を問わず本サービスを変更する行為。</li>
        <li>本サービスに関して、リバースエンジニアリング、逆コンパイル、逆アセンブル及びその他方法、態様の如何を問わず、本サービスを解析する行為。</li>
        <li>本サービスを利用する権利につき、有償無償を問わず、譲渡、再販売、担保設定及びその他処分、使用権許諾等する行為。</li>
        <li>本サービスに関して、意図的に誤情報や有害なコンピュータープログラム等を送信する行為。</li>
        <li>本サービス及びその他当社の事業運営に支障をきたす恐れのある行為。</li>
        <li>当社または第三者が有する著作権、特許権、商標権等の知的財産権を侵害する行為、またはその恐れのある行為。</li>
        <li>当社または第三者のプライバシーを侵害する行為、名誉もしくは信用を毀損する行為、またはその恐れのある行為。</li>
        <li>法令、本規約または公序良俗に反する行為、及び当社または第三者に不利益を与える行為。</li>
        <li>本サービスの利用に関して、反社会的勢力に直接または間接に利益を提供する行為。</li>
        <li>その他前各号に該当する恐れがある行為、これに類する行為、またはその他当社が不適切と判断した行為。</li>
      </ol>
      <p>お客様の行為または不作為が本条における禁止事項に該当するか否かは、当社の判断によるものとします。</p>

      <h4>第６条 免責事項</h4>
      <ol>
        <li>本サービスに記載された乗換案内データ等について、十分注意、確認した上で掲載しておりますが、必ずしも最適な経路の検索、必ずしも最新、正確または完全でない場合があり、またお客様の使用目的または要求を満たすものではない場合があります。ご利用にあたっては、お客様ご自身の責任においてご利用ください。</li>
        <li>本サービスで提供する情報は時刻表をもとに検索しています。ただし、交通状況等により異なる運行がされている場合がありますのでご了承ください。</li>
        <li>迂回ルート表示におきまして、運行状況の乱れがある場合があります。この検索結果は、標準的なダイヤ情報を用いているため、実際の運行と異なることがあることをご了承ください。なお、運行状況、発車時刻等は各交通機関にお尋ねください。</li>
        <li>本サービスに記載された乗換案内データ等につき、お客様は、お客様の使用目的または要求を満たすものではなく、また全て正確かつ完全ではない場合でも、当社または、株式会社ヴァル研究所がデータの交換・修補その他の責任を負いません。</li>
        <li>お客様と、本サービス中に広告を行っている広告主または本サービスがリンクしている他のウェブサイトにて行われる事業の事業主との間の取引については、全てお客様とかかる広告主または事業主との責任において行われることとし、当社はかかる取引に関してお客様が被る損害・損失について如何なる保証もせず、また責任を負いません。</li>
        <li>本サービスをご利用いただくための環境が不完全であることに起因する動作不良やその他の諸影響に関して、当社は責任を負いません。また、お客様のOSやネットワーク環境、ご利用機器やソフトウェアの構成等に起因する動作不良やその他の諸影響に関しても当社は責任を負いません。</li>
        <li>本サービスの利用に起因してお客様が損害を被った場合でも、当社、株式会社ヴァル研究所は、その損害が自らの故意または重大な過失に起因して生じたものでない限り、責任を負いません。</li>
      </ol>

      <h4>第７条 サービスの停止・変更</h4>
      <p>当社は、本サービスの全部または一部について、予告なく変更、中断または終了することがありますが、当社は、かかる変更、中断または終了によりお客様に生じる損害について、賠償責任その他の責任を負いません。</p>

      <h4>第8条 個人情報及びその他の情報の取扱い</h4>
      <ol>
        <li>当社は、本サービスの提供を通じて当社が取得するお客様の個人情報について、当社所定の「<Link href="https://www.ana.co.jp/ja/jp/share/privacy/" color='secondary' rel="noopener" target="_blank" >プライバシーポリシー</Link>」を遵守し、適切に管理するものとします。</li>
        <li>当社は、お客様による本サービスの利用によって取得する情報（目的地等のデータ、GPS機能により取得される位置情報、移動経路情報を含みますが、これらに限られません）について、本サービス若しくはこれに関連するサービスまたは当社のその他の事業のために利用（統計資料の作成、及び当該事業に必要な範囲において第三者に提供することを含みます）することがあります。</li>
        <li>当社は、前項の情報を第三者に提供する場合、適切な匿名化処置を施し、匿名化した情報を再識別化しないものとします。また、これらの情報を第三者に提供する場合には、提供先が再識別化をすることを契約で禁止します。その他、第1項に定める「<Link href="https://www.ana.co.jp/ja/jp/share/privacy/" color='secondary' rel="noopener" target="_blank" >プライバシーポリシー</Link>」の規定によらずに、お客様の個人情報を第三者に提供することはありません。</li>
        <li>当社は、お客様の個人情報を基にまたは第2項の情報を基に作成した統計資料について、個人を識別できるものではないことを前提に、取り扱うことができるものとします。</li>
      </ol>

      <h4>第９条 損害賠償</h4>
      <p>お客様が、本規約に対する違反行為、または不正行為若しくは違法行為により、当社に損害を与えた場合、当社はそのお客様に対し、かかる違反行為、不正行為または違法行為に基づき生じた損害について、その賠償を請求できるものとします。</p>

      <h4>第１０条 一般条項</h4>
      <ol>
        <li>当社は、本規約を変更することがあります。</li>
        <li>当社が本規約の改訂・修正を行う場合は、改訂・修正内容と効力発生時期を本サービスのウェブサイト等の当社の選択する方法で事前に告知します。本規約の変更が効力を生じた後にお客様が本サービスを利用された場合、お客様は変更後の本規約の全ての記載内容に同意したものとみなします。</li>
        <li>本規約の効力、解釈及び履行については日本国法に準拠するものとします。</li>
        <li>本規約に関して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
      </ol>

      <p className={classes.right}>以 上</p>
    </div>
  )
}

export default TermsBodyJP;
